import { render, staticRenderFns } from "./day-goals.vue?vue&type=template&id=3d6d23fd&scoped=true&"
import script from "./day-goals.vue?vue&type=script&lang=js&"
export * from "./day-goals.vue?vue&type=script&lang=js&"
import style0 from "./day-goals.vue?vue&type=style&index=0&id=3d6d23fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6d23fd",
  null
  
)

export default component.exports